import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import map from "../../assets/withdrawals/map.js";
import Back from "../../baseComponents/Back";
import Dialog from "../../baseComponents/Dialog";
import {
  setCurrentNode,
  resetNode,
} from "../../redux/features/withdrawals/withdrawals";
import { Spring } from "react-spring";
import {
  AnimatedSprite,
  Container,
  Sprite,
  TilingSprite,
  useApp,
} from "@inlet/react-pixi/animated";
import LottieSprite from "../../baseComponents/LottieSprite";
import NodeAnimation from "../../baseComponents/NodeAnimation";
import data from "../../assets/anim/cat.json";
import data2 from "../../assets/anim/404.json";
import data3 from "../../assets/anim/smile.json";
import { easeCubicInOut } from "d3-ease";
import { setTransition } from "../../redux/features/transition";
import GameContainer from "../../baseComponents/GameContainer/Index";
import data4 from "../../assets/anim/scroll_up_correct.json";
import { setSection } from "../../redux/features/general.js";
import Avatar from "./components/Avatar";
import TimeCount from "./components/TimeCount.js";
import laptop from "../../assets/anim/laptop.json";
import trees from "../../assets/map/trees/tree1.png";
import TitleContainer from "../../baseComponents/TitleContainer.js";
import image from "../../assets/withdrawals/instrucciones_juego2.png";
import ending1 from "../../assets/withdrawals/03final.png";
import ending2 from "../../assets/withdrawals/01final.png";
import ending3 from "../../assets/pension/paso19.png";
import Quotes from "../../baseComponents/Quotes.js";
import { addTime, resetTime } from "../../redux/features/withdrawals/time";
import rasterizeSVG from "../../utils/rasterizeSVG.js";
import { interruptAudio } from "../../redux/features/audio.js";
import woman from "../../assets/anim/woman.json";
import phoneGuy from "../../assets/anim/phone guy.json";
import appPhone from "../../assets/anim/phone03.json";
import desk from "../../assets/anim/desk guy.json";
import search from "../../assets/anim/laptop search.json";
import LottiePixiLoader from "../../utils/LottiePixiLoader.js";

import message1 from "../../assets/games/ValidarIdentidad/instrucciones.png";
import DialogRectangle from "../../baseComponents/DialogRectangle";
import Frustrometro from "../FullWithdrawal/components/Frustometro.js";
import random from "../../utils/random.js";

export default function Withdrawals() {
  const spring = { mass: 1, tension: 100, friction: 50 };

  const Animated = () => {
    const frames = LottiePixiLoader(
      [90, 320, 310, 545, 600],
      [woman, phoneGuy, desk, search, appPhone]
    );
    const { info } = useSelector((state) => state.info);
    const scale = window.innerWidth / 1536;
    const [showTitle, setShowTitle] = useState(0);
    const [titleImage, setTitleImage] = useState(image);
    const [showAvatar, setShowAvatar] = useState(false);
    const [avatarStart, setAvatarStart] = useState(true);
    const [showQuotes, setShowQuotes] = useState(1);
    const [isAnimationsPlaying, setAnimationsPlaying] = useState(false);
    const dispatch = useDispatch();

    const { currentNode, anchor } = useSelector((state) => state.withdrawals);
    const lastNode = useRef(currentNode);
    const endingImage = [ending1, ending2, ending3];

    useEffect(() => {
      /*
      dispatch(setTransition(false));

      setTimeout(() => {
        setShowTitle(1);
      }, 1000);
      */
      return () => {
        dispatch(resetNode());
        //dispatch(resetTime());
      };
    }, []);

    useEffect(() => {
      if (!!frames.length) {
        setTimeout(() => {
          dispatch(setTransition(false));

          setTimeout(() => {
            if (!showTitle) setShowTitle(1);
          }, 1000);
        }, 500);
      }
    }, [frames]);

    useEffect(() => {
      if (currentNode.isLast) {
        if (typeof currentNode.ending === "number") {
          setTitleImage(endingImage[currentNode.ending]);
        }
        setShowTitle(info ? 0 : 1);
      }
    }, [currentNode, info]);

    const handleAudio = (interrupted) => {
      //console.log(interrupted);
      dispatch(interruptAudio(interrupted));
    };

    const onAction = (id) => {
      if (!currentNode.descendants.length) return;

      const descendant = currentNode.descendants[id];
      if (descendant.random) {
        const nextNode = random(descendant.random);
        dispatch(setCurrentNode(nextNode || 0));
        lastNode.current = currentNode;
        setShowQuotes(1);
      } else {
        dispatch(setCurrentNode(currentNode.descendants[id].node || 0));
        lastNode.current = currentNode;
        setShowQuotes(1);
      }
      //dispatch(addTime(currentNode.time || 0));
    };

    const handleBack = () => {
      dispatch(setTransition(true));
      setTimeout(() => {
        dispatch(setSection("menu"));
        dispatch(resetTime());
      }, 1000);
    };

    const handleDialogClose = () => {
      setShowQuotes(0);
    };

    const onCloseGame = (stay, gameId = 0) => {
      if (stay) {
        return dispatch(setCurrentNode(lastNode.current));
      }

      onAction(gameId);

      /*
      
      if (!currentNode.descendants.length) return;

      const descendant = currentNode.descendants[id];
      if (descendant.random) {
        const nextNode = random(descendant.random);
        dispatch(setCurrentNode(nextNode || 0));
        lastNode.current = currentNode;
        setShowQuotes(1);
      } else {
        dispatch(setCurrentNode(currentNode.descendants[id].node || 0));
        lastNode.current = currentNode;
        setShowQuotes(1);
      }
      console.log(
        "WithDrawals onAction",
        id,
        currentNode.message,
        descendant.random
      );
      
      */
    };

    //console.log(currentNode);

    return (
      <Spring
        to={{
          x: currentNode.anchor.x * scale,
          y: currentNode.anchor.y * scale,
          anchor: [window.innerWidth / 2.1, window.innerHeight / 2],
        }}
        config={{ duration: 1000, easing: easeCubicInOut }}
      >
        {(props) => (
          <Container>
            <Container position={props.anchor}>
              <Container {...props} pivot={[0, scale * 983 * 2.5]}>
                <Sprite
                  image={rasterizeSVG(map, [
                    scale * 1593 * 2.5,
                    scale * 983 * 2.5,
                  ])}
                />
                {!!frames.length && (
                  <>
                    <Container position={[2000 * scale, 650 * scale]}>
                      <AnimatedSprite
                        position={[0, 0]}
                        textures={frames[4]}
                        isPlaying={isAnimationsPlaying}
                        initialFrame={0}
                        animationSpeed={0.5}
                      />
                    </Container>
                    <Container position={[715 * scale, 2490 * scale]}>
                      <AnimatedSprite
                        position={[0, 0]}
                        textures={frames[3]}
                        isPlaying={isAnimationsPlaying}
                        initialFrame={0}
                        animationSpeed={0.5}
                      />
                    </Container>
                    <Container position={[3360 * scale, 1085 * scale]}>
                      <AnimatedSprite
                        position={[0, 0]}
                        textures={frames[0]}
                        isPlaying={isAnimationsPlaying}
                        initialFrame={0}
                        animationSpeed={0.3}
                      />
                    </Container>
                    <Container
                      position={[3100 * scale, 1060 * scale]}
                      scale={[-1, 1]}
                    >
                      <AnimatedSprite
                        position={[0, 0]}
                        textures={frames[1]}
                        isPlaying={isAnimationsPlaying}
                        initialFrame={0}
                        animationSpeed={0.3}
                      />
                    </Container>
                    <Container position={[1428 * scale, 1034 * scale]}>
                      <AnimatedSprite
                        position={[0, 0]}
                        textures={frames[3]}
                        isPlaying={isAnimationsPlaying}
                        initialFrame={0}
                        animationSpeed={0.5}
                      />
                    </Container>
                    <Container
                      position={[4020 * scale, 785 * scale]}
                      scale={[-1, 1]}
                    >
                      <AnimatedSprite
                        position={[0, 0]}
                        textures={frames[2]}
                        isPlaying={isAnimationsPlaying}
                        initialFrame={0}
                        animationSpeed={0.3}
                      />
                    </Container>
                  </>
                )}
              </Container>
            </Container>
            {showAvatar && (
              <Container position={props.anchor} scale={scale}>
                <Avatar
                  anchor={currentNode.anchor}
                  prevDirection={lastNode.current.direction}
                  direction={currentNode.direction}
                  begin={avatarStart}
                />
              </Container>
            )}
            <Back click={handleBack} />
            {showAvatar && (
              <Quotes
                quotes={currentNode.quotes}
                visible={showQuotes}
                ageRange={[40, 60]}
                titleColor="#092C74"
                position={
                  (currentNode.direction && currentNode.type === 0) ||
                  (!currentNode.direction && currentNode.type === 1)
                }
              />
            )}
            {typeof currentNode.game !== "number" &&
              showAvatar &&
              !currentNode.isLast &&
              (currentNode.type === 100 ? (
                <DialogRectangle
                  id={0}
                  message={currentNode.message}
                  currentNode={currentNode}
                  onClose={() => null}
                  close={() => onAction(0)}
                  button={"games[id] && games[id].dialogButton"}
                />
              ) : (
                <Dialog
                  id={currentNode}
                  {...currentNode.dialogAnchor}
                  delay={
                    currentNode.anchor.x === lastNode.current.anchor.x &&
                    currentNode.anchor.y === lastNode.current.anchor.y
                      ? 0
                      : 2000
                  }
                  message={currentNode.message}
                  buttons={
                    currentNode.descendants
                      ? currentNode.descendants.map((e, i) => {
                          e.key = i;
                          //console.log(e);
                          return e.hint;
                        })
                      : []
                  }
                  type={currentNode.type}
                  action={onAction}
                  currentNode={currentNode}
                  addTime={addTime}
                  onClose={handleDialogClose}
                  buttonsActive={true || typeof currentNode.audio !== "number"}
                />
              ))}
            <GameContainer
              descendants={currentNode.descendants}
              id={currentNode.game}
              lastId={lastNode.current && lastNode.current.game}
              close={(stay, gameId) => onCloseGame(stay, gameId)}
              back={() => handleBack()}
            />
            <TitleContainer
              image={titleImage}
              //video={
              //  "https://alucinaprojects.s3.us-west-2.amazonaws.com/profuturo/Profuturo-Video-Retiro.mp4"
              // }
              scale={showTitle}
              isLast={currentNode.isLast}
              onVideoVisible={() => handleAudio(true)}
              hasEndingMessage={typeof currentNode.ending === "number"}
              commentPos={0}
              close={() => {
                if (currentNode.isLast) handleBack();
                setAnimationsPlaying(true);
                setShowTitle(0);
                setShowAvatar(true);
                setAvatarStart(false);
                handleAudio(false);
              }}
              buttonsPosition={[
                window.innerWidth / 4.8,
                window.innerHeight / 2 + 225 * scale,
              ]}
              worldType={1}
            />
            <TimeCount setFinalScore={currentNode.isLast} />
            <Frustrometro time={0} />
          </Container>
        )}
      </Spring>
    );
  };

  return <Animated />;
}
